import classNames from "classnames";

interface TextStatProps {
  label: string;
  value: number | string;
  labelOnTop?: boolean;
  valueClassName?: string;
  labelClassName?: string;
}

export const TextStat = ({
  label,
  value,
  labelOnTop = false,
  valueClassName = "",
  labelClassName = "",
}: TextStatProps) => {
  const valueY = labelOnTop ? "70%" : "40%";
  const labelY = labelOnTop ? "25%" : "75%";

  return (
    <svg
      viewBox="0 0 110 110"
      preserveAspectRatio="xMidYMid meet"
      className="w-full h-full"
    >
      <text
        x={"50%"}
        y={valueY}
        className={classNames("text-5xl font-bold font-mono", valueClassName)}
        alignmentBaseline="middle"
        dominantBaseline="middle"
        textAnchor="middle"
      >
        {value}
      </text>
      <text
        x={"50%"}
        y={labelY}
        className={classNames("text-xl font-semibold", labelClassName)}
        alignmentBaseline="middle"
        dominantBaseline="middle"
        textAnchor="middle"
      >
        {label}
      </text>
    </svg>
  );
};
